// choose-your-shade modal start
document.addEventListener("DOMContentLoaded", function() {
  const openModalBtn = document.querySelector(".choose-your-shade-open-modal-btn");
  const closeModalBtn = document.querySelector(".choose-your-shade-close-modal-btn");
  const modalOverlay = document.querySelector(".choose-your-shade-modal-overlay");

  // ✅ Exit early if the required button doesn't exist
  if (!openModalBtn || !closeModalBtn || !modalOverlay) return;

  // Open modal
  openModalBtn.addEventListener("click", function() {
    modalOverlay.classList.add("show");
  });

  // Close modal
  closeModalBtn.addEventListener("click", function() {
    modalOverlay.classList.remove("show");
  });

  // Close when clicking outside modal
  modalOverlay.addEventListener("click", function(event) {
    if (event.target === modalOverlay) {
      modalOverlay.classList.remove("show");
    }
  });
});
// choose-your-shade modal end


    // B21012025 when scroll from top atc button animation will start
    document.addEventListener("DOMContentLoaded", function () {
        const button = document.querySelector('.btn-anim');
    
        // Add scroll event listener
        window.addEventListener('scroll', function () {
            if (window.scrollY >= 200) {
                button.classList.add('scroll-active');
                //console.log('scroll size >>>' + window.scrollY);
            } else {
                button.classList.remove('scroll-active');
            }
        });
    });
 // end when scroll from top atc button animation will start


 document.addEventListener("DOMContentLoaded", function () {
    // Initially hide the popup
    document.getElementById("popup-cstm_dev").classList.add("hidden");
  
    // Desktop Popup Trigger
    document.querySelectorAll(".cstm_dev_popup").forEach(function (el, index) {
      el.addEventListener("click", function () {
        const pdpTags = document.querySelectorAll(".popup-content-cstm_dev .pdp-tag");
        pdpTags.forEach(tag => tag.classList.remove("active"));
        if (pdpTags[index]) {
          pdpTags[index].classList.add("active");
        }
  
        document.querySelectorAll(".custom-tab-pane").forEach(pane => pane.style.display = "none");
        const tabContent = document.getElementById("tab-content-" + (index + 1));
        if (tabContent) tabContent.style.display = "block";
  
        const popup = document.getElementById("popup-cstm_dev");
        popup.classList.remove("hidden");
        popup.classList.add("pop__visible");
      });
    });
  
    // Close Desktop Popup
    document.getElementById("closePopup-cstm_dev").addEventListener("click", function () {
      const popup = document.getElementById("popup-cstm_dev");
      popup.classList.remove("pop__visible");
      popup.classList.add("hidden");
    });
  
    // Desktop Tab Switching Inside Popup
    document.querySelectorAll(".popup-content-cstm_dev .pdp-tag").forEach(function (tag, index) {
      tag.addEventListener("click", function () {
        document.querySelectorAll(".popup-content-cstm_dev .pdp-tag").forEach(t => t.classList.remove("active"));
        tag.classList.add("active");
  
        document.querySelectorAll(".custom-tab-pane").forEach(pane => pane.style.display = "none");
        const content = document.getElementById("tab-content-" + (index + 1));
        if (content) content.style.display = "block";
      });
    });
  
    // Mobile Popup Trigger
    document.querySelectorAll(".cstm_dev_popup_mob").forEach(function (el, index) {
      el.addEventListener("click", function () {
        const popup = document.getElementById("popup-cstm_dev_mob");
        popup.classList.remove("hidden");
        popup.classList.add("pop__visible");
  
        const tabPanes = document.getElementsByClassName("custom-tab-pane-mob");
        const tabButtons = popup.querySelectorAll(".pdp-tag");
  
        for (let i = 0; i < tabPanes.length; i++) {
          tabPanes[i].style.display = "none";
          tabButtons[i].classList.remove("active");
        }
  
        if (tabPanes[index] && tabButtons[index]) {
          tabPanes[index].style.display = "block";
          tabButtons[index].classList.add("active");
        }
      });
    });
  
    // Mobile Tab Switching
    const mobTags = document.querySelectorAll("#popup-cstm_dev_mob .pdp-tag");
    mobTags.forEach(function (tag, index) {
      tag.addEventListener("click", function () {
        const tabPanes = document.getElementsByClassName("custom-tab-pane-mob");
        mobTags.forEach(t => t.classList.remove("active"));
  
        for (let i = 0; i < tabPanes.length; i++) {
          tabPanes[i].style.display = "none";
        }
  
        tag.classList.add("active");
        if (tabPanes[index]) tabPanes[index].style.display = "block";
      });
    });
  
    // Close Mobile Popup
    document.getElementById("closePopup-cstm_dev_mob").addEventListener("click", function () {
      const popup = document.getElementById("popup-cstm_dev_mob");
      popup.classList.remove("pop__visible");
      popup.classList.add("hidden");
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    // Initially disable all minus buttons
    document.querySelectorAll(".minus-button").forEach(function (btn) {
      btn.classList.add("disabled");
    });
  
    // Plus button logic
    document.querySelectorAll(".plus-button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const qtyInput = this.parentElement.querySelector(".qty-input-val");
        let currentVal = parseInt(qtyInput.value);
        if (!isNaN(currentVal)) {
          qtyInput.value = currentVal + 1;
  
          // Update dev_getqty inputs
          document.querySelectorAll(".dev_getqty").forEach(function (el) {
            el.value = currentVal + 1;
          });
          document.querySelectorAll("#qty-input-val-web").forEach(function (el) {
            el.value = currentVal + 1;
          });
          
  
          // Enable minus buttons
          document.querySelectorAll(".minus-button").forEach(function (el) {
            el.classList.remove("disabled");
          });
        }
      });
      
    });
  
    // Minus button logic
    document.querySelectorAll(".minus-button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const qtyInput = this.parentElement.querySelector(".qty-input-val");
        let currentVal = parseInt(qtyInput.value);
        if (!isNaN(currentVal) && currentVal > 1) {
          qtyInput.value = currentVal - 1;
  
          document.querySelectorAll(".dev_getqty").forEach(function (el) {
            el.value = currentVal - 1;
          });
          document.querySelectorAll("#qty-input-val-web").forEach(function (el) {
            el.value = currentVal - 1;
          });
  
          if (currentVal <= 2) {
            this.classList.add("disabled");
          }
        }
      });
    });
  
    // Manual input change
    document.querySelectorAll(".qty-input-val").forEach(function (input) {
      input.addEventListener("change", function () {
        let currentVal = parseInt(this.value);
  
        if (isNaN(currentVal) || currentVal < 1) {
          this.value = 1;
          currentVal = 1;
        }
  
        // Update dev_getqty values
        document.querySelectorAll(".dev_getqty").forEach(function (el) {
          el.value = currentVal;
        });
  
        // Enable or disable minus buttons
        document.querySelectorAll(".minus-button").forEach(function (btn) {
          if (currentVal <= 1) {
            btn.classList.add("disabled");
          } else {
            btn.classList.remove("disabled");
          }
        });
      });
    });
  });

  
document.addEventListener("click", function (event) {
    if (event.target.classList.contains("dev_add_btn")) {
      event.preventDefault();
      event.stopPropagation();
  
      const currentId = event.target.getAttribute("data-ref");
      const form = document.getElementById(currentId);
  
      if (form) {
        const addToCartBtn = form.querySelector("button.devx_add_to_cart_button");
        if (addToCartBtn) {
          addToCartBtn.click();
        }
      }
    }
  });


  document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.couponCodeContainerDesktop').forEach(function(container) {
      container.addEventListener('click', function() {
          // Get the coupon code text from the clicked container
          var couponCodeDesktop = container.querySelector('.couponCodeDesktop').innerText;
          // Copy the coupon code to the clipboard
          navigator.clipboard.writeText(couponCodeDesktop).then(function() {
          // Hide originalMessage and show copiedContent within the clicked container
          container.querySelector('.originalMessageDesktop').style.display = 'none';
          container.querySelector('.copiedContentDesktop').style.display = 'flex';
          // After 3 seconds, revert the visibility
          setTimeout(function() {
            container.querySelector('.originalMessageDesktop').style.display = 'flex';
            container.querySelector('.copiedContentDesktop').style.display = 'none';
            }, 3000);
          });
      });
   });
});

document.addEventListener("click", function (event) {
    if (event.target.classList.contains("dev_apply_combo")) {
      // Remove 'v_active' from all .variant-btn elements
      document.querySelectorAll(".variant-btn").forEach(function (btn) {
        btn.classList.remove("v_active");
      });
  
      // Add 'v_active' to clicked element
      event.target.classList.add("v_active");
  
      // Clear bottom bar text
      document.querySelectorAll(".pdp-size-bottom-bar").forEach(function (el) {
        el.textContent = "";
      });
  
      // Update title and price text
      const title = event.target.getAttribute("data-product-title");
      const price = event.target.getAttribute("data-product-price");
  
      document.querySelectorAll(".dev_pdp-title-bottom-bar").forEach(function (el) {
        el.textContent = title;
      });
  
      document.querySelectorAll("#stky-dfl-selected-variant-price").forEach(function (el) {
        el.textContent = price;
      });
  
      // Set input values
      const productId = event.target.getAttribute("data-product-id");
      const variantId = event.target.getAttribute("data-product-variant-id");
  
      document.querySelectorAll(".dev_getproductid").forEach(function (el) {
        el.value = productId;
      });
  
      document.querySelectorAll(".dev_getvariantid").forEach(function (el) {
        el.value = variantId;
      });
    }
  });


  
document.addEventListener("click", function (event) {
    if (event.target.classList.contains("dev_apply_combo")) {
      // Remove 'v_active' from all .variant-btn elements
      document.querySelectorAll(".variant-btn").forEach(function (btn) {
        btn.classList.remove("v_active");
      });
  
      // Add 'v_active' to clicked element
      event.target.classList.add("v_active");
  
      // Clear bottom bar text
      document.querySelectorAll(".pdp-size-bottom-bar").forEach(function (el) {
        el.textContent = "";
      });
  
      // Update title and price text
      const title = event.target.getAttribute("data-product-title");
      const price = event.target.getAttribute("data-product-price");
  
      document.querySelectorAll(".dev_pdp-title-bottom-bar").forEach(function (el) {
        el.textContent = title;
      });
  
      document.querySelectorAll("#stky-dfl-selected-variant-price").forEach(function (el) {
        el.textContent = price;
      });
  
      // Set input values
      const productId = event.target.getAttribute("data-product-id");
      const variantId = event.target.getAttribute("data-product-variant-id");
  
      document.querySelectorAll(".dev_getproductid").forEach(function (el) {
        el.value = productId;
      });
  
      document.querySelectorAll(".dev_getvariantid").forEach(function (el) {
        el.value = variantId;
      });
    }
  });


 // Replace the existing handleOptionClick function with this fixed version:

// function handleOptionClick(element, optionName, optionValue, productId, productSKU) {
//   if (element.classList.contains('v_active')) return;

//   // Reset title text
//   const productTitle = document.getElementById("product-data").dataset.productTitle;
//   document.querySelectorAll('.dev_pdp-title-bottom-bar').forEach(el => {
//     el.textContent = productTitle;
//   });

//   // Set product ID inputs and remove active classes
//   document.querySelectorAll('.dev_getproductid').forEach(el => {
//     el.value = productId;
//   });
//   document.querySelectorAll('.dev_apply_combo').forEach(el => {
//     el.classList.remove('v_active');
//   });

//   // Update color text
//   const devColorName = document.querySelector('.dev_color_name');
//   if (devColorName) {
//     devColorName.textContent = optionValue;
//   }

//   // EDD on click change sku id
//   // assign sku code into product_sku_code input
//   // const skuInput = document.querySelector('.product_sku_code');
//   // if (skuInput) {
//   //   skuInput.value = productSKU;
//   // }else{
//   //   skuInput.value = '';
//   // }

//   // // get address pin from input field 
//   // let eddPincode = document.getElementById('edd-get-pincode-pdp-tempStore').value;
//   // if (eddPincode === '') {
//   //   // alert('not fetch eddPincode');
//   //   document.getElementById('edd-get-pincode-pdp-label').innerHTML = 'Enter Your Pincode';
//   //   document.getElementById('edd-get-pincode-pdp').value = '';
//   //   document.getElementById('edd-get-pincode-pdp').placeholder = 'Enter Pincode';
//   // }else{
//   //   document.getElementById('edd-get-pincode-pdp-label').innerHTML = 'Checking delivery date...';
//   //   document.getElementById('edd-get-pincode-pdp').value = '';
//   //   document.getElementById('edd-get-pincode-pdp').placeholder = 'Enter Pincode';

//   //   // this fetchAccessToken function declare on edd-section.js
//   //   fetchAccessToken(eddPincode, productSKU);
//   // }
//   // end EDD

  

//   // Store selected option
//   selectedOptions[optionName] = optionValue;

//   // Get variant data from HTML
//   const variantDataEl = document.getElementById("product-data");
//   const variants = JSON.parse(variantDataEl.dataset.variants);

//   const matchedVariant = variants.find(variant =>
//     Object.keys(selectedOptions).every(key =>
//       variant.option1 === selectedOptions[key] ||
//       variant.option2 === selectedOptions[key] ||
//       variant.option3 === selectedOptions[key]
//     )
//   );

//   if (matchedVariant) {
//     const hideIfNoVarElems = document.querySelectorAll('.dev_hide_if_novar');
//     const disableIfNoVarElems = document.querySelectorAll('.dev_disable_if_novar');
//     const qtySltorElems = document.querySelectorAll('.npdp-details-qty-sltor');

//     if (matchedVariant.available) {
//       hideIfNoVarElems.forEach(el => el.textContent = "ADD TO CART");
//       disableIfNoVarElems.forEach(el => el.disabled = false);
//       qtySltorElems.forEach(el => el.style.display = '');
//     } else {
//       hideIfNoVarElems.forEach(el => el.textContent = "SOLD OUT");
//       disableIfNoVarElems.forEach(el => el.disabled = true);
//       qtySltorElems.forEach(el => el.style.display = 'none');
//     }

//     // Set variant ID inputs
//     document.querySelectorAll('.dev_getvariantid').forEach(el => {
//       el.value = matchedVariant.id;
//     });

//     // Format prices
//     let formattedPrice = `₹${(matchedVariant.price / 100).toFixed(2)}`;
//     if (formattedPrice.endsWith('.00')) {
//       formattedPrice = formattedPrice.slice(0, -3);
//     }

//     let comparePrice = `₹${(matchedVariant.compare_at_price / 100).toFixed(2)}`;
//     if (comparePrice.endsWith('.00')) {
//       comparePrice = comparePrice.slice(0, -3);
//     }

//     // Discount percentage
//     const comp = parseFloat(comparePrice.replace('₹', ''));
//     const original = parseFloat(formattedPrice.replace('₹', ''));
//     const discountPercent = Math.floor((comp - original) / comp * 100);

//     document.querySelectorAll('.dev_change_percentage').forEach(el => {
//       el.innerHTML = `(${discountPercent}% OFF)`;
//     });

//     // Update prices in DOM
//     const dflPrice = document.getElementById('dfl-selected-variant-price');
//     if (dflPrice) dflPrice.innerHTML = formattedPrice;

//     const stickyPrice = document.getElementById('stky-dfl-selected-variant-price');
//     if (stickyPrice) stickyPrice.innerHTML = formattedPrice;

//     document.querySelectorAll('.compare-at-price').forEach(el => {
//       el.innerHTML = comparePrice;
//     });

//     const pdpSizeBar = document.querySelector('.pdp-size-bottom-bar');
//     if (pdpSizeBar) pdpSizeBar.innerHTML = `(${optionValue})`;

//     // Variant button active class toggle
//     const variantDisplay = element.closest('.pdp-variant-display');
//     if (variantDisplay) {
//       variantDisplay.querySelectorAll(`.variant-button-${productId}`).forEach(btn => {
//         btn.classList.remove('v_active');
//       });
//     }
//     element.classList.add('v_active');

//     // FIXED: Scroll to variant image
//     if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
//       const container = document.querySelector('.pdp-images');
//       const allImages = document.querySelectorAll('.pdp-images .pdp-image img');
      
//       if (container && allImages.length > 0) {
//         let targetImageIndex = -1;
        
//         // Find the matching image by comparing src URLs
//         for (let i = 0; i < allImages.length; i++) {
//           const img = allImages[i];
//           const imgSrc = img.src.split('?')[0]; // Remove query parameters
//           const variantSrc = matchedVariant.featured_image.src.split('?')[0]; // Remove query parameters
          
//           if (imgSrc.includes(variantSrc.split('/').pop()) || variantSrc.includes(imgSrc.split('/').pop())) {
//             targetImageIndex = i;
//             break;
//           }
//         }
        
//         // If image found, scroll to it
//         if (targetImageIndex >= 0) {
//           const targetImage = allImages[targetImageIndex];
//           const imageContainer = targetImage.closest('.pdp-image');
          
//           if (imageContainer) {
//             const containerRect = container.getBoundingClientRect();
//             const imageRect = imageContainer.getBoundingClientRect();
//             const scrollLeft = container.scrollLeft + imageRect.left - containerRect.left;
            
//             container.scrollTo({
//               left: scrollLeft,
//               behavior: 'smooth'
//             });
//           }
//         }
//       }
//     }

//     document.querySelectorAll('.dev_change_comp_id').forEach(el => {
//       el.textContent = comparePrice;
//     });
//   }
// }

// ab testing vitamin-c-e-sunscreen-spf-50-pa 17-10-2025 Thumbnail Slider
// slider start 
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".pdp-image-section .pdp-images");
  const thumbContainer = document.querySelector(".pdp-thumbnails");

  if (!container) return;

  // ===== variables =====
  let isPointerDown = false;
  let pointerId = null;
  let startX = 0;
  let startScroll = 0;
  let currentIndex = 0;
  let moved = 0;
  let slideWidth = container.clientWidth;

  // recalc on resize (important)
  window.addEventListener("resize", () => {
    slideWidth = container.clientWidth;
    // snap to current index to keep alignment
    container.scrollTo({ left: currentIndex * slideWidth, behavior: "instant" });
  });

  // helper: go to slide index (clamped)
  function goToSlide(index) {
    const slides = container.querySelectorAll(".pdp-image");
    const max = Math.max(0, slides.length - 1);
    index = Math.max(0, Math.min(max, index));
    currentIndex = index;
    container.scrollTo({ left: slideWidth * index, behavior: "smooth" });
    if (typeof window.updateActiveThumbnail === "function") window.updateActiveThumbnail(index);
    // update active class
    document.querySelectorAll(".pdp-images .pdp-image").forEach((el, idx) => {
      el.classList.toggle("active", idx === index);
    });
  }

  // initialize active index from current scroll
  function refreshCurrentIndex() {
    const idx = Math.round(container.scrollLeft / slideWidth);
    currentIndex = Math.max(0, Math.min((container.querySelectorAll('.pdp-image').length - 1), idx));
    if (typeof window.updateActiveThumbnail === "function") window.updateActiveThumbnail(currentIndex);
  }
  refreshCurrentIndex();

  // Use pointer events (unifies mouse & touch) to avoid "shaking"
  container.addEventListener("pointerdown", (e) => {
    // only left mouse or touch/pen
    if (e.button && e.button !== 0) return;

    isPointerDown = true;
    pointerId = e.pointerId;
    container.setPointerCapture(pointerId);

    startX = e.clientX;
    startScroll = container.scrollLeft;
    moved = 0;

    // while dragging, use instant scrolling (no built-in smooth)
    container.style.scrollBehavior = "auto";
    container.style.cursor = "grabbing";

    // prevent default to avoid selecting text
    e.preventDefault();
  });

  container.addEventListener("pointermove", (e) => {
    if (!isPointerDown || e.pointerId !== pointerId) return;
    const dx = e.clientX - startX;
    moved = dx;
    // invert movement: moving finger left should increase scrollLeft
    container.scrollLeft = startScroll - dx;
  });

  function endPointer(e) {
    if (!isPointerDown || e.pointerId !== pointerId) return;
    isPointerDown = false;
    try { container.releasePointerCapture(pointerId); } catch (err) {}
    pointerId = null;

    container.style.cursor = "grab";
    // restore smooth snapping
    container.style.scrollBehavior = "smooth";

    // Determine threshold (20% of slide width)
    const threshold = slideWidth * 0.2;

    // moved positive -> finger moved right -> we should go previous
    if (moved > threshold) {
      goToSlide(currentIndex - 1);
    } else if (moved < -threshold) {
      goToSlide(currentIndex + 1);
    } else {
      // snap to nearest (prevent small shakes)
      const nearest = Math.round(container.scrollLeft / slideWidth);
      goToSlide(nearest);
    }
  }

  container.addEventListener("pointerup", endPointer);
  container.addEventListener("pointercancel", endPointer);
  container.addEventListener("lostpointercapture", endPointer);

  // Prevent accidental click on interactive children when dragging
  let clickPrevent = false;
  container.addEventListener("click", (e) => {
    // if moved more than small px, suppress the click
    if (Math.abs(moved) > 8) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  }, true);

  // ===== ARROW NAVIGATION (unchanged behavior, now uses goToSlide) =====
  const nextArrow = document.getElementById("next-arrow");
  const prevArrow = document.getElementById("prev-arrow");

  if (nextArrow) {
    nextArrow.addEventListener("click", (ev) => {
      ev.preventDefault();
      goToSlide(currentIndex + 1);
    });
  }
  if (prevArrow) {
    prevArrow.addEventListener("click", (ev) => {
      ev.preventDefault();
      goToSlide(currentIndex - 1);
    });
  }

  // ===== GENERATE THUMBNAILS ===== (keeps your existing look & behaviour)
  let thumbs = [];
  if (thumbContainer) {
    thumbContainer.innerHTML = ""; // ensure empty
    const images = container.querySelectorAll(".pdp-image img.pdp-slide-image");
    images.forEach((img, index) => {
      const thumb = document.createElement("img");
      thumb.src = img.src;
      thumb.classList.add("thumb-image");
      thumb.style.cssText =
        "width:60px;height:60px;object-fit:cover;border-radius:6px;margin-right:8px;cursor:pointer;transition:all .3s;border:1px solid transparent;";
      if (index === 0) thumb.style.border = "1px solid black";

      thumb.addEventListener("click", (ev) => {
        ev.preventDefault();
        goToSlide(index);
      });
      thumbContainer.appendChild(thumb);
      thumbs.push(thumb);
    });

    thumbContainer.style.cssText =
      "display:none;align-items:center;overflow-x:auto;margin-top:12px;padding:5px 0; width:90%; margin: auto;";
  }

  // ===== Update Active Thumbnail (exposed) =====
  window.updateActiveThumbnail = function (targetImageIndex) {
    if (!thumbContainer) return;
    const t = thumbContainer.querySelectorAll("img");
    t.forEach((thumb, idx) => {
      thumb.style.border = idx === targetImageIndex ? "1px solid #ff40b1" : "1px solid transparent";
    });
  };

  // ===== Sync thumbnail while scrolling ends (safety) =====
  container.addEventListener("scroll", () => {
      const idx = Math.round(container.scrollLeft / slideWidth);
      if (idx !== currentIndex) {
        currentIndex = idx;
        updateActiveThumbnail(idx);
        // keep active class in main slides
        document.querySelectorAll(".pdp-images .pdp-image").forEach((el, i) => {
          el.classList.toggle("active", i === idx);
        });
      }
  });

  // ensure initial state
  goToSlide(currentIndex);
});

// slider end 
// end ab testing fixing thumnail issue on mobile main product slider - grabbing touch (24-10-2025)
// end new js for code 17-10-2025 PDP page main product slider


function handleOptionClick(element, optionName, optionValue, productId) {
  if (element.classList.contains('v_active')) return;

  // Reset title text
  const productTitle = document.getElementById("product-data").dataset.productTitle;
  document.querySelectorAll('.dev_pdp-title-bottom-bar').forEach(el => {
    el.textContent = productTitle;
  });

  // Set product ID inputs and remove active classes
  document.querySelectorAll('.dev_getproductid').forEach(el => {
    el.value = productId;
  });
  document.querySelectorAll('.dev_apply_combo').forEach(el => {
    el.classList.remove('v_active');
  });

  // Update color text
  const devColorName = document.querySelector('.dev_color_name');
  if (devColorName) {
    devColorName.textContent = optionValue;
  }

  // Store selected option
  selectedOptions[optionName] = optionValue;

  // Get variant data from HTML
  const variantDataEl = document.getElementById("product-data");
  const variants = JSON.parse(variantDataEl.dataset.variants);

  const matchedVariant = variants.find(variant =>
    Object.keys(selectedOptions).every(key =>
      variant.option1 === selectedOptions[key] ||
      variant.option2 === selectedOptions[key] ||
      variant.option3 === selectedOptions[key]
    )
  );

  if (matchedVariant) {
    const hideIfNoVarElems = document.querySelectorAll('.dev_hide_if_novar');
    const disableIfNoVarElems = document.querySelectorAll('.dev_disable_if_novar');
    const qtySltorElems = document.querySelectorAll('.npdp-details-qty-sltor');

    if (matchedVariant.available) {
      hideIfNoVarElems.forEach(el => el.textContent = "ADD TO CART");
      disableIfNoVarElems.forEach(el => el.disabled = false);
      qtySltorElems.forEach(el => el.style.display = '');
    } else {
      hideIfNoVarElems.forEach(el => el.textContent = "SOLD OUT");
      disableIfNoVarElems.forEach(el => el.disabled = true);
      qtySltorElems.forEach(el => el.style.display = 'none');
    }

    // Set variant ID inputs
    document.querySelectorAll('.dev_getvariantid').forEach(el => {
      el.value = matchedVariant.id;
    });

    // Format prices
    let formattedPrice = `₹${(matchedVariant.price / 100).toFixed(2)}`;
    if (formattedPrice.endsWith('.00')) {
      formattedPrice = formattedPrice.slice(0, -3);
    }

    let comparePrice = `₹${(matchedVariant.compare_at_price / 100).toFixed(2)}`;
    if (comparePrice.endsWith('.00')) {
      comparePrice = comparePrice.slice(0, -3);
    }

    // Discount percentage
    const comp = parseFloat(comparePrice.replace('₹', ''));
    const original = parseFloat(formattedPrice.replace('₹', ''));
    const discountPercent = Math.floor((comp - original) / comp * 100);

    document.querySelectorAll('.dev_change_percentage').forEach(el => {
      el.innerHTML = `(${discountPercent}% OFF)`;
    });

    // Update prices in DOM
    const dflPrice = document.getElementById('dfl-selected-variant-price');
    if (dflPrice) dflPrice.innerHTML = formattedPrice;

    const stickyPrice = document.getElementById('stky-dfl-selected-variant-price');
    if (stickyPrice) stickyPrice.innerHTML = formattedPrice;

    document.querySelectorAll('.compare-at-price').forEach(el => {
      el.innerHTML = comparePrice;
    });

    const pdpSizeBar = document.querySelector('.pdp-size-bottom-bar');
    if (pdpSizeBar) pdpSizeBar.innerHTML = `(${optionValue})`;

    // Variant button active class toggle
    const variantDisplay = element.closest('.pdp-variant-display');
    if (variantDisplay) {
      variantDisplay.querySelectorAll(`.variant-button-${productId}`).forEach(btn => {
        btn.classList.remove('v_active');
      });
    }
    element.classList.add('v_active');

    // FIXED: Scroll to variant image
    if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
      const container = document.querySelector('.pdp-images');
      const allImages = document.querySelectorAll('.pdp-images .pdp-image img.pdp-slide-image');
      
      let matchedImageContainer = null;

      if (container && allImages.length > 0) {
        let targetImageIndex = -1;
        const variantSrc = matchedVariant.featured_image.src.split('?')[0]; // Remove query parameters
        let matchedImageContainer = null;

        // Find the matching image by comparing src URLs
        for (let i = 0; i < allImages.length; i++) {
          const img = allImages[i];
          const imgSrc = img.src.split('?')[0]; // Remove query parameters

          // console.log('Checking image:', imgSrc);
          // console.log('Variant image:', variantSrc);

          // Compare clean URLs directly
          if (imgSrc === variantSrc || imgSrc.includes(variantSrc.split('/').pop())) {
            targetImageIndex = i;
            matchedImageContainer = img.closest('.pdp-image');
            break;
          }
        }

        if (matchedImageContainer) {
          // Remove 'active' from all
          document.querySelectorAll('.pdp-images .pdp-image').forEach(el => {
            el.classList.remove('active');
          });

          // Add 'active' to matched one
          matchedImageContainer.classList.add('active');
          // console.log('✅ Active image updated:', matchedImageContainer);

          // Scroll to the active image smoothly
          const containerRect = container.getBoundingClientRect();
          const imageRect = matchedImageContainer.getBoundingClientRect();
          const scrollLeft = container.scrollLeft + imageRect.left - containerRect.left;

          container.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        } else {
          console.warn('⚠️ No matching image found for variant.');
        }

        // Optional: update main slider active image if needed
        if (targetImageIndex >= 0) {
          const targetImage = allImages[targetImageIndex];
          const activeContainer = document.querySelector('#mainImageSlider .pdp-image.active');
          if (activeContainer) {
            const imgTag = activeContainer.querySelector('img.pdp-slide-image');
            if (imgTag) {
              // console.log('Variant matched image:', variantSrc);
              imgTag.src = variantSrc;
            }
          } else {
            console.warn('No active image container found in main slider.');
          }
        }
      }
    }

    document.querySelectorAll('.dev_change_comp_id').forEach(el => {
      el.textContent = comparePrice;
    });
  }
}




  // slide.classList.toggle('active', i === index);

  // var isDragging = false;
  // var startX, scrollLeft;

  // const container = document.querySelector('.pdp-image-section .pdp-images');
  // container.style.cursor = 'grab';

  // container.addEventListener('mousedown', function(e) {
  //   isDragging = true;
  //   startX = e.pageX - container.offsetLeft;
  //   scrollLeft = container.scrollLeft;
  //   container.style.cursor = 'grabbing';
  //   e.preventDefault(); // prevent text selection
  // });

  // document.addEventListener('mouseup', function() {
  //   isDragging = false;
  //   container.style.cursor = 'grab';
  // });

  // container.addEventListener('mousemove', function(e) {
  //   if (!isDragging) return;
  //   const x = e.pageX - container.offsetLeft;
  //   const walk = (x - startX) * 1; // Adjust scroll speed
  //   container.scrollLeft = scrollLeft - walk;
  // });

  // jquery code
  // This is for the offers abr

  var isDraggingForOffer = false;
  var startXOffer, scrollLeftoffer;
  
  const offerContainer = document.querySelector('.npdp-offers .contents-slider');
  
  // Check if element exists
  if (offerContainer) {
      // Set initial cursor style
      offerContainer.style.cursor = 'grab';
  
      offerContainer.addEventListener('mousedown', function(e) {
          isDraggingForOffer = true;
          const rect = offerContainer.getBoundingClientRect();
          startXOffer = e.clientX - rect.left;
          scrollLeftoffer = offerContainer.scrollLeft;
          offerContainer.style.cursor = 'grabbing';
          e.preventDefault(); // prevent text selection
      });
  
      document.addEventListener('mouseup', function() {
          if (isDraggingForOffer) {
              isDraggingForOffer = false;
              offerContainer.style.cursor = 'grab';
          }
      });
  
      offerContainer.addEventListener('mousemove', function(e) {
          if (!isDraggingForOffer) return;
          const rect = offerContainer.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const walk = (x - startXOffer) * 1; // Adjust scroll speed
          offerContainer.scrollLeft = scrollLeftoffer - walk;
      });
  
      // Prevent dragging images
      offerContainer.addEventListener('dragstart', function(e) {
          e.preventDefault();
      });
  }
//end jquery 
  

// document.addEventListener('DOMContentLoaded', function() {
//   const fullwidth = window.innerWidth;
//   const cardwidth = fullwidth > 768 ? fullwidth / 2 : fullwidth;

//   const nextArrow = document.getElementById('next-arrow');
//   const prevArrow = document.getElementById('prev-arrow');

//   if (nextArrow) {
//     nextArrow.addEventListener('click', function() {
//       const parent = this.closest('.pdp-container');
//       const container = parent ? parent.querySelector('.pdp-images') : null;
//       if (container) {
//         container.scrollBy({
//           left: cardwidth,
//           behavior: 'smooth'
//         });
//       }
//     });
//   }

//   if (prevArrow) {
//     prevArrow.addEventListener('click', function() {
//       const parent = this.closest('.pdp-container');
//       const container = parent ? parent.querySelector('.pdp-images') : null;
//       if (container) {
//         container.scrollBy({
//           left: -cardwidth,
//           behavior: 'smooth'
//         });
//       }
//     });
//   }
// });


  document.addEventListener('DOMContentLoaded', function () {
    var rating = parseFloat(localStorage.getItem('avgRating')) || 0;

    var fullStars = Math.floor(rating);
    var hasHalfStar = rating - fullStars > 0;
    var blankStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    // Global counter for unique gradient IDs
    let gradientIdCounter = 0;

    function createFullStarSvg() {
      return `
      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L14.09 8.26L21 9.27L16 14.14L17.18 21.02L12 17.77L6.82 21.02L8 14.14L3 9.27L9.91 8.26L12 2Z"
          fill="#82B51B"/>
      </svg>
    `;
    }

    function createHalfStarSvg() {
      // Use and increment global counter for uniqueness
      const uniqueId = `halfGradient_${gradientIdCounter++}`;
      return `
      <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="${uniqueId}" x1="0" y1="0" x2="1" y2="0">
            <stop offset="50%" stop-color="#82B51B"/>
            <stop offset="50%" stop-color="#E0E0E0"/>
          </linearGradient>
        </defs>
        <path d="M12 2L14.09 8.26L21 9.27L16 14.14L17.18 21.02L12 17.77L6.82 21.02L8 14.14L3 9.27L9.91 8.26L12 2Z"
          fill="url(#${uniqueId})"/>
      </svg>
    `;
    }

    function createBlankStarSvg() {
      return `
      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L14.09 8.26L21 9.27L16 14.14L17.18 21.02L12 17.77L6.82 21.02L8 14.14L3 9.27L9.91 8.26L12 2Z"
          fill="#E0E0E0"/>
      </svg>
    `;
    }

    function renderStars(targetSelector) {
      const container = document.querySelector(targetSelector);
      if (!container) {
        console.warn(`No container found for selector: ${targetSelector}`);
        return;
      }

      container.innerHTML = '';

      for (let i = 0; i < fullStars; i++) {
        container.insertAdjacentHTML('beforeend', createFullStarSvg());
      }

      if (hasHalfStar) {
        container.insertAdjacentHTML('beforeend', createHalfStarSvg());
      }

      for (let i = 0; i < blankStars; i++) {
        container.insertAdjacentHTML('beforeend', createBlankStarSvg());
      }
    }

    renderStars('.ratings');
    renderStars('.mob_ratings');
  });
  
  // Function to calculate blank star count
  function getBlankStarCount(rating) {
    const totalStars = 5;
    if (rating < 0 || rating > totalStars) {
      throw new Error('Rating must be between 0 and the total number of stars.');
    }
    const fullStars = Math.floor(rating);
    const hasPartialStar = rating % 1 > 0;
    return totalStars - fullStars - (hasPartialStar ? 1 : 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const carousel = document.querySelector('.npdp_available_offers_slider');
    let isDragging = false;
    let startX, scrollLeft;

    // Prevent text selection during dragging
    carousel.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
      carousel.style.cursor = 'grabbing';

      // Prevent text selection when dragging
      document.body.style.userSelect = 'none';
    });

    carousel.addEventListener('mouseup', function () {
      isDragging = false;
      carousel.style.cursor = 'grab';

      // Re-enable text selection when dragging stops
      document.body.style.userSelect = 'auto';
    });

    carousel.addEventListener('mousemove', function (e) {
      if (!isDragging) return; // Only move if dragging is active
      e.preventDefault(); // Prevent text selection during drag
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 3; // Adjust speed (3 is a multiplier)
      carousel.scrollLeft = scrollLeft - walk;
    });

    carousel.addEventListener('mouseleave', function () {
      isDragging = false;
      carousel.style.cursor = 'grab';

      // Re-enable text selection if mouse leaves carousel
      document.body.style.userSelect = 'auto';
    });
  });

  var bottom_sticky_title_search = setInterval(function () {
    // Select the target container where the new div should be inserted
    var parentElement = document.querySelector('.npdp-fxd-btm-atc');
    var referenceElement = document.querySelector('div.flex.justify-between.align-center.npdp-inside-container');
    // console.log('variant - adding nudge on the addtocart sticky bar - depended element searching');

    if (referenceElement !== null && parentElement !== null) {
      // console.log('variant - adding nudge on the addtocart sticky bar - adding nudge code execution');
      clearInterval(bottom_sticky_title_search);

      // Create the new div element
      var newDiv = document.createElement('div');
      newDiv.classList.add('scroll-container');
      newDiv.style.cssText = `
      width: 100%;
      height: 40px;
      background: #FFF1F2;
      border-radius: 20px 20px 0px 0px;
      display: none; /* Initially hidden */
      justify-content: center;
      align-items: center;
      position: relative;
      overflow: hidden;
      font-size: 14px;
      color: #000;
      box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1); /* Only top shadow */
    `;

      // Update reference element styling
      referenceElement.style.cssText = 'border: none !important; border-radius: unset !important;';

      // Create scrolling text containers
      var scrollText1 = document.createElement('div');
      scrollText1.classList.add('scroll-text');
      scrollText1.style.cssText = `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      position: absolute;
      opacity: 0;
    `;
      scrollText1.innerHTML =
        '<img src="https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Shipping.png?v=1730184747" alt="shipping truck" width="30" height="30" style="margin-right: 8px;"> Free Shipping on order Rs.399 & above';

      var scrollText2 = document.createElement('div');
      scrollText2.classList.add('scroll-text');
      scrollText2.style.cssText = `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      position: absolute;
      opacity: 0;
    `;
      scrollText2.innerHTML =
        '<img src="https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Payment.png?v=1730184747" alt="secure payment" width="23" height="23" style="margin-right: 8px;"> 100% Secure Transaction';

      newDiv.appendChild(scrollText1);
      newDiv.appendChild(scrollText2);
      parentElement.insertBefore(newDiv, referenceElement);

      // Add keyframes and animation styles
      var styleSheet = document.createElement('style');
      styleSheet.type = 'text/css';
      styleSheet.innerText = `
      .scroll-text {
        animation: scroll 6s ease-in-out infinite;
      }
      .scroll-text:nth-child(1) { animation-delay: 0s; }
      .scroll-text:nth-child(2) { animation-delay: 3s; }
  
      @keyframes scroll {
        0%, 17% { opacity: 0; transform: translateY(100%); }
        20%, 53% { opacity: 1; transform: translateY(0); }
        56%, 100% { opacity: 0; transform: translateY(-100%); }
      }
    `;
      document.head.appendChild(styleSheet);

      // Show and hide the scroll-container based on scroll activity
      var hideTimeout;

      // #B22012025 scroll from top - scroll-container div hide or show on pdp page before atc button
      window.addEventListener('scroll', function () {
        // Show the scroll-container when scrolling starts
        // newDiv.style.display = 'flex';
        const scrollContainer = document.querySelector('.scroll-container');

        if (window.scrollY >= 500) {
          scrollContainer.style.display = 'flex'; // Add display: flex
        } else {
          scrollContainer.style.display = 'none'; // Set display: none
        }
      });
    }
  }, 600);

  // npdp page when scroll footer will visible 
  document.addEventListener('DOMContentLoaded', function() {
    const fixedBottomBar = document.querySelector('.npdp-fxd-btm-atc');
    const BottomNavBar = document.querySelector('.bottom-nav-bar-parent');

    function toggleFixedBottomBar() {
      // Get current pathname
      const currentPath = window.location.pathname;
      const targetHandle = "/products/vitamin-c-moisturizer";

      // Run only on the matching product page
      if (currentPath === targetHandle) {
        if (window.pageYOffset > 1000) {
            fixedBottomBar.classList.add('visible');
            // BottomNavBar.classList.add('visible');
        } else {
            fixedBottomBar.classList.remove('visible');
            // BottomNavBar.classList.remove('visible');
        }
      }
        
    }

    window.addEventListener('scroll', toggleFixedBottomBar, { passive: true });
  });

  // in mobile view atc button position change and visable for this perticulat product
  document.addEventListener('DOMContentLoaded', function () {
    // Get current pathname
    const currentPath = window.location.pathname;

    const fixedBottomBar = document.querySelector('.npdp-fxd-btm-atc');

    // Target product handle (no query params)
    const targetHandle = "/products/vitamin-c-moisturizer";

    // Run only on the matching product page
    if (currentPath === targetHandle) {
      // console.log("Custom JS running only on SPF 50 product page 🚀");

      // Select the ATC button
      const addToBagBtn = document.getElementById('main-atc-btn');

      if (addToBagBtn) {
        // console.log("Found ATC button:", addToBagBtn);

        // Force display visible
        addToBagBtn.style.setProperty("display", "flex", "important");
        addToBagBtn.style.setProperty("margin", "block", "important");
      }

      // Inject custom CSS for element ordering
      // const style = document.createElement("style");
      // style.innerHTML = `
      //   .npdp-details-total-sold.mobile-visible {
      //     order: 2;
      //   }
      //   .pdp-tags.mobile-visible {
      //     order: 3;
      //   }
      //   .pdp-skin-type.mobile-visible {
      //     order: 4;
      //   }
      //   .pdp-skin-type.mobile-visible {
      //     order: 5;
      //   }
      //   .pdp-add-to-bag.devx_pdp_add_to_cart {
      //     order: 1;
      //   }
      // `;
      // document.head.appendChild(style);
    }else{
      fixedBottomBar.classList.add('visible');
      
    }
  });


// pdp atc qnt button
document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.getElementById("npdp-details-qty-sltor-web");
  const input = document.getElementById("qty-input-val-web");


  wrapper.addEventListener("click", (e) => {
    let currentVal = parseInt(input.value) || 1;

    if (e.target.classList.contains("minus-button")) {
      // currentVal = currentVal > 1 ? currentVal - 1 : 1; // prevent 0
      // syncAllQtyInputs(currentVal);
      // console.log("Minus clicked → current value:", currentVal);
      document.querySelectorAll(".qty-input-val").forEach(el => el.value = currentVal);
    }

    if (e.target.classList.contains("plus-button")) {
      // currentVal = currentVal + 1;
      // syncAllQtyInputs(currentVal);
      // console.log("Plus clicked → current value:", currentVal);
      document.querySelectorAll(".qty-input-val").forEach(el => el.value = currentVal);
    }
  });
});